var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryUserIcon123(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.441,
    height: 13.442,
    viewBox: "0 0 30.441 13.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "123-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31803",
    "data-name": "Rectangle 31803",
    width: 30.441,
    height: 13.442,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "123-Group_14097",
    "data-name": "Group 14097",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "123-Path_40513",
    "data-name": "Path 40513",
    d: "M3.442.22,0,1.821.5,4.1l2.48-1.18h.04v10.3h2.94V.22Z",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "123-Group_14096",
    "data-name": "Group 14096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "123-Group_14095",
    "data-name": "Group 14095",
    clipPath: "url(#123-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "123-Path_40514",
    "data-name": "Path 40514",
    d: "M10.24,13.223V11.382l1.68-1.519c2.841-2.541,4.22-4,4.26-5.522,0-1.06-.639-1.9-2.139-1.9a4.7,4.7,0,0,0-2.781,1.08L10.4,1.34A7.2,7.2,0,0,1,14.661,0c2.94,0,4.56,1.72,4.56,4.081,0,2.18-1.58,3.921-3.46,5.6l-1.2,1v.04h4.9v2.5Z",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "123-Path_40515",
    "data-name": "Path 40515",
    d: "M21.88,10.242a7.168,7.168,0,0,0,3.021.8c1.581,0,2.38-.76,2.38-1.74,0-1.281-1.28-1.861-2.621-1.861H23.42V5.261H24.6c1.02-.02,2.32-.4,2.32-1.5,0-.781-.64-1.361-1.92-1.361a5.939,5.939,0,0,0-2.721.78L21.66.98A8.144,8.144,0,0,1,25.681,0C28.462,0,30,1.46,30,3.24a3.114,3.114,0,0,1-2.381,3.021V6.3a3.231,3.231,0,0,1,2.821,3.161c0,2.3-2.02,3.98-5.321,3.98a7.677,7.677,0,0,1-3.861-.92Z",
    fill: "#2e2e2d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryUserIcon123);
export default __webpack_public_path__ + "static/media/EntryUser_Icon_123.bf1104c721de3db58995f5a5e3ec1d23.svg";
export { ForwardRef as ReactComponent };